<template>
  <c-card>
    <c-card-header>
      <div>
        <c-icon name="cil-task" />
        Toasts
        <a href="https://coreui.io/pro/vue/" rel="noreferrer noopener" target="_blank" class="badge badge-danger ml-1">
          CoreUI Pro
        </a>
        <div class="card-header-actions">
          <a
            href="https://coreui.io/vue/docs/components/toast"
            class="card-header-action"
            rel="noreferrer noopener"
            target="_blank"
          >
            <small class="text-muted">docs</small>
          </a>
        </div>
      </div>
    </c-card-header>
    <c-row>
      <c-col sm="12" lg="6">
        <c-form class="m-4">
          <h5>Add toast with following props:</h5>
          <c-input-checkbox :checked.sync="autohide" custom label="Autohide of the toast" class="my-2 mt-4" />
          <c-input
            v-if="autohide"
            :value.sync="autohideValue"
            type="number"
            lazy
            label="Time to autohide"
            class="my-2"
          />
          <c-select :value.sync="position" :options="positions" custom label="Position" class="my-2" />

          <c-input-checkbox :checked.sync="fade" custom label="fade" class="my-2" />

          <c-input-checkbox :checked.sync="closeButton" custom label="closeButton" class="my-2" />

          <c-button class="mr-1 w-25" color="success" @click="addToast()">
            Add toast
          </c-button>
        </c-form>
      </c-col>
      <c-col sm="12" lg="6">
        <div class="m-4">
          <c-toaster v-for="(toaster, toasterKey) in toasters" :key="'toaster' + toasterKey" :position="toasterKey">
            <template v-for="(toast, key) in toaster">
              <c-toast :key="'toast' + key" :show="true" v-bind="toast">
                {{ `This is a toast in ${toasterKey} positioned toaster number ${key + 1}.` }}
              </c-toast>
            </template>
          </c-toaster>
        </div>
      </c-col>
    </c-row>
  </c-card>
</template>

<script>
export default {
  name: 'Toaster',
  data() {
    return {
      toasts: [
        { position: 'static', header: 'Toast title' },
        { position: 'static', header: 'Toast title' },
        { position: 'top-right', header: 'Toast title', autohide: 3000 },
      ],
      autohide: true,
      autohideValue: 5000,
      closeButton: true,
      fade: true,
      position: 'top-right',
      header: 'Toast title',
      positions: [
        'static',
        'top-left',
        'top-center',
        'top-right',
        'top-full',
        'bottom-left',
        'bottom-center',
        'bottom-right',
        'bottom-full',
      ],
    };
  },
  computed: {
    toastConfig() {
      return {
        autohide: this.autohide ? this.autohideValue : false,
        closeButton: this.closeButton,
        fade: this.fade,
        position: this.position,
        header: this.header,
      };
    },
    toasters() {
      return this.toasts.reduce((toasters, toast) => {
        toasters[toast.position] = toasters[toast.position] || [];
        toasters[toast.position].push(toast);
        return toasters;
      }, {});
    },
  },
  methods: {
    addToast() {
      this.toasts.push(this.toastConfig);
    },
  },
};
</script>
